import { useEffect, useState } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useAmbassadorCode } from '~/@biz_ambassador/code/useAmbassadorCode'

type Props = {
  isAuthenticated: boolean
}

/**
 * Public landing for `/ambassador/:ambassadorCode`. Stores the referral code,
 * then sends logged-in users to my-ambassador and guests to registration.
 */
export default function AmbassadorLandingPage({ isAuthenticated }: Props) {
  const { ambassadorCode } = useParams<{ ambassadorCode: string }>()
  const { setAmbassadorCode } = useAmbassadorCode()
  const [isStored, setIsStored] = useState(false)

  useEffect(() => {
    if (ambassadorCode) setAmbassadorCode(ambassadorCode)
    setIsStored(true)
  }, [ambassadorCode, setAmbassadorCode])

  // Wait until the code is persisted before redirecting.
  if (!isStored) return null

  return (
    <Navigate
      to={isAuthenticated ? '/settings/my-ambassador' : '/register'}
      replace
    />
  )
}
